import { AxiosResponse } from 'axios';
import Repository from './Repository';
import { IProducts } from './product.interface';

const resource = '/products';

export default class ProductRepository {
  public static getProducts = (contractId?: string | null): Promise<AxiosResponse<IProducts>> => {
    const url = contractId ? `${resource}/get?contractId=${contractId}` : `${resource}/get`;
    return Repository.post(url);
  };
}
